import DiscretesAndTrends from "./DiscretesAndTrends";
export default DiscretesAndTrends;
